import { Amendment } from "../types/Amendments";

export const convertToCSV = (amendments: Amendment[]): string => {
  if (!amendments || amendments.length === 0) {
    return "";
  }

  // Define CSV headers
  const headers = [
    "ID Amendement",
    "Nom du fichier",
    "ID Fichier",
    "ID Député",
    "Prénom",
    "Nom",
    "Date de création",
    "Article",
    "Paragraphe",
    "Tri",
    "Ordre ID",
    "Emplacement",
    "Statut",
    "Contenu",
    "Résumé du contenu",
    "Titre",
    "Score",
    "Nom du groupe",
    "Résumé",
  ];

  // Convert amendments data to CSV rows
  const csvRows = amendments.map((amendment) => [
    amendment.AmendmentId || "",
    amendment.FileName || "",
    amendment.FileId || "",
    amendment.DeputyId || "",
    amendment.FirstName || "",
    amendment.LastName || "",
    amendment.CreatedAt || "",
    amendment.Article || "",
    amendment.Paragraph?.toString() || "",
    amendment.Sort || "",
    amendment.IdOrder?.toString() || "",
    amendment.Spot || "",
    amendment.Status || "",
    amendment.Content || "",
    amendment.ContentSummary || "",
    amendment.Title || "",
    amendment.Score?.join("; ") || "",
    amendment.GroupName || "",
    amendment.Summary || "",
  ]);

  // Escape CSV values and wrap in quotes if necessary
  const escapeCSVValue = (value: string): string => {
    if (value.includes('"') || value.includes(",") || value.includes("\n")) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  };

  // Build the complete CSV content
  const csvContent = [
    headers.map(escapeCSVValue).join(","),
    ...csvRows.map((row) => row.map(escapeCSVValue).join(",")),
  ].join("\n");

  return csvContent;
};

export const downloadCSV = (
  csvContent: string,
  filename: string = "amendements.csv"
): void => {
  // Create a Blob with the CSV content
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

  // Create a download link
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";

  // Append to body, click, and remove
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up the URL object
  URL.revokeObjectURL(url);
};

export const exportAmendmentsToCSV = (
  amendments: Amendment[],
  filename?: string
): void => {
  const csvContent = convertToCSV(amendments);
  const timestamp = new Date().toISOString().split("T")[0];
  const defaultFilename = `amendements_${timestamp}.csv`;

  downloadCSV(csvContent, filename || defaultFilename);
};
